module.exports = __webpack_public_path__ + "static/media/chu-desktop.d06f259e.jpg";